import { OrderShippingStatus } from '../utils';

export enum OrderOperationStatus {
  ORDER_CREATED = 'ORDER CREATED',
  AUTO_CREATE_SPID = 'AUTO CREATE SPID',
  PENDING_APPROVAL = 'PENDING APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING_REJECTION = 'PENDING REJECTION',
  PENDING_REJECTED = 'PENDING REJECTED',
  PENDING_DELIVERY = 'PENDING DELIVERY',
  PENDING_DO_UPLOAD = 'PENDING DO UPLOAD',
  UPLOAD_SIGN_DO = 'UPLOAD SIGN DO',
  PENDING_SIGN_DO_UPLOAD = 'PENDING SIGN DO UPLOAD',
  COMPLETED = 'COMPLETED',
  COMPLETED_TENTATIVE = 'COMPLETED TENTATIVE',
  PO_CANCELLED = 'PO CANCELLED',
  CANCELLED_FROM_MP = 'CANCELLED_FROM_MP',
  OOS = 'OOS',
  ADDED_TO_MARKETPLACE = 'ADDED TO MARKETPLACE',
  PURCHASED = 'PURCHASED',
}

export enum OrderPaymentStatus {
  PENDING_INVOICE_SUBMISSION = 'PENDING INVOICE SUBMISSION',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  PENDING_PAYMENT = 'PENDING PAYMENT',
  INVOICE_DISPUTED = 'INVOICE_DISPUTED',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
}

export type OrderV2 = {
  id: number;
  region_ref_number: string;
  project_code?: string; // null,
  po_reference_number: string;
  purchase_request_number?: string;
  region: string;
  assignee: string;
  assignee_user_name?: string;
  assignee_region_identifier: string;
  buyer_email: string;
  entity_name: string;
  shipping_address: string;
  total_price_all: number;
  total_price: number;
  total_price_fulfilled: number;
  total_external_remittance: number;
  total_cost: number;
  current_tax: number;
  all_fulfilled_qty: number;
  all_fulfilled_amt: number;
  all_qty: number;
  cumulative_margin: number;
  cumulative_margin_percentage: number;
  total_margin: number;
  currency: string;
  operation_status: OrderOperationStatus;
  payment_status: OrderPaymentStatus;
  shipping_status: OrderShippingStatus;
  issue_date: string;
  invoice_date?: string; // null,
  do_date?: string; // null,
  payment_date?: string; // null,
  days_to_fulfill?: any; // null,
  xero_sync_date?: string; // null,
  xero_sync_user?: {
    full_name: string;
    username: string;
  };
  xero_sync_payload?: Record<string, any>;
  xero_invoice_id?: string;
  is_consolidated_line_items?: string; // null,
  is_ncpr: boolean; // false,
  email_reader_pur_ref_sync?: {
    synced_at?: string | null;
    status?: string | null;
  } | null;
  updated_at: string; // "2024-07-24 07:41:54",
  created_at: string; // "2024-07-24 07:40:11"
  tracking_number?: string;
  reason?: string;
  external_po_number?: string;
  journal_number?: string[]; // ScalarListType stores as array
  consolidate_po_number?: string;
  is_without_po?: boolean;
  buyer_name: string;
  buyer_phone_number: string;
  created_by_user_name?: string;
  requester_name?: string;
  requester_email?: string;
  remarks?: string;
  shipping_address_from_er?: string;
  completed_at?: string;
  supplier_payment_list?: Array<{
    total_payable: number;
  }>;
};

export type OrderItemV2 = {
  id: number;
  name: string;
  category: string;
  supplier_id?: number;
  supplier?: string;
  billing_party_id?: number;
  billing_party?: string;
  paid_by?: 'SS_PAID' | 'CLIENT_PAID';
  is_ncpr: boolean;
  spids?: number[];
  quantity: number;
  fulfilled_qty: number;
  currency: string;
  price: number;
  total: number;
  cost: number;
  tax: number;
  total_cost: number;
  category_item_name?: string;
  note?: string;
  expected_delivery_date?: string;
  external_url?: string;
  external_id?: string;
};

export type OrderItemAuditLog = {
  id: number;
  row_id: number;
  column_name: string;
  old_value: string | null;
  new_value: string;
  created_at: string;
  created_by?: { full_name: string } | null;
  user?: { full_name: string } | null;
  remark?: string;
};
